const LOAD_DATA_MASTER_BANK           = 'LOAD_DATA_MASTER_BANK'
const LOAD_DATA_MASTER_BANK_SUCCESS   = 'LOAD_DATA_MASTER_BANK_SUCCESS'
const LOAD_DATA_MASTER_BANK_FAILED    = 'LOAD_DATA_MASTER_BANK_FAILED'
const UNMOUNT_DATA_MASTER_BANK        = 'UNMOUNT_DATA_MASTER_BANK'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterBankReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_BANK:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_BANK_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_BANK_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_BANK:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterBankReducer;